import { defineSlotRecipe } from '@chakra-ui/react';

export const dataDisplaySlotRecipe = defineSlotRecipe({
	slots: [ 'root', 'header', 'gridItem', 'content' ],

	base: {
		content: { p: 10 },

		gridItem: {
			'borderBottom':      '1px solid',
			'borderBottomColor': 'gray.15',
			'p':                 6,

			'&:nth-of-type(even)': {
				bg:        'white',
				textStyle: 'body',
			},
			'&:nth-of-type(odd)': {
				bg:        'gray.10',
				textStyle: 'bodyBold',
			},
		},
		header: {
			borderBottomColor: 'gray.15',
			borderColor:       'gray.15',
			p:                 4,
			textStyle:         'h3',
		},
		root: {
			border:       '1px solid',
			borderColor:  'gray.15',
			borderRadius: 'lg',
			overflow:     'hidden',
		},
	},
});
